<div class="boxFooter">
    <img (click)="expand()" src="/assets/images/Expand.svg" />
    <div (click)="save()" class="button">Save</div>
</div>
